<section id="skills">
    <div class="container">
        <h2>
            <strong>Services</strong>
        </h2>
        <span class="bar-title mb-5"></span>
        <div class="row mt-2">
            <div class="services-pill" aria-label="Fish selection" *ngFor="let service of services">
                <span color="warn">{{service}}</span>
            </div>
        </div>
    </div>
</section>